// extracted by mini-css-extract-plugin
export default {"initErrorContainer":"init-error_initErrorContainer__sF4WC","initErrorContent":"init-error_initErrorContent__KPUU4"};